import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { SearchService } from '../../../shared/services/search.service';
import type { CountrySearchResult, LocationSearchResult } from '@sal/location/application/ports';
import { TranslatePipe } from '@ngx-translate/core';
import { SiCardComponent } from '@siemens/element-ng/card';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { ResultItemType } from '../../../shared/enums/result-item-type.enum';

@Component({
    selector: 'app-result-item',
    templateUrl: './result-item.component.html',
    styleUrls: ['./result-item.component.scss'],
    imports: [TranslatePipe, SiCardComponent, SiIconComponent]
})
export class ResultItemComponent {
    private readonly router = inject(Router);
    private readonly searchService = inject(SearchService);
    protected readonly ResultItemType = ResultItemType;

    public readonly type = input.required<ResultItemType>();
    public readonly itemLocation = input<LocationSearchResult | null>(null);
    public readonly itemCountry = input<CountrySearchResult | null>(null);

    public openItem(): void {
        this.searchService.storeSearchBoxState(false);

        if (this.type() === ResultItemType.COUNTRY) {
            const country = this.itemCountry();
            if (!country) {
                return;
            }
            void this.router.navigate([`country/detail/${country.isoCode2}`]);
            return;
        }

        const location = this.itemLocation();
        if (!location) {
            return;
        }
        void this.router.navigate([`location/detail/${location.salId}`]);
    }
}
